import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ApiKeyService = /** @class */ (function () {
    function ApiKeyService(http) {
        this.http = http;
    }
    ApiKeyService.prototype.get = function () {
        return this.http.get('/users/api-key');
    };
    ApiKeyService.prototype.generate = function () {
        return this.http.post('/users/api-key', {});
    };
    ApiKeyService.prototype.revoke = function () {
        return this.http.delete('/users/api-key');
    };
    ApiKeyService.ngInjectableDef = i0.defineInjectable({ factory: function ApiKeyService_Factory() { return new ApiKeyService(i0.inject(i1.HttpClient)); }, token: ApiKeyService, providedIn: "root" });
    return ApiKeyService;
}());
export { ApiKeyService };
